import { journeyElementsStore } from '../JourneyElementsStore';

export const getLocationById = (locationId: string) => {
	return journeyElementsStore.getState().locations.find(x => x.id === locationId);
};
